import React, { FC } from 'react';
import { Link as ReactLink } from 'react-router';

import moment from 'moment';

import Typography from '@mui/material/Typography';

import footerLogo from '@assets/logos/footerLogo.png';

import Container from '@components/common/Container';
import Link from '@components/common/Link';

import { SOCIAL_LINKS } from '@constants/common/footer.constants';
import { PATH_INDEX } from '@constants/common/routes.constants';

import useStyles from './styles.module';

const CURRENT_YEAR = moment().year();

const Footer: FC = () => {
  const { classes } = useStyles();

  return (
    <footer className={classes.footer}>
      <Container className={classes.box}>
        <div className={classes.left}>
          <ReactLink to={PATH_INDEX}>
            <img
              src={footerLogo}
              className={classes.logo}
              alt="logo dexFinance"
            />
          </ReactLink>
          {/*<Typography*/}
          {/*  variant="caption1"*/}
          {/*  color={(theme) => theme.palette.custom.text.light}*/}
          {/*>*/}
          {/*  DeFi investing carries risk. Smart contracts can have*/}
          {/*  vulnerabilities, and yields are notguaranteed. Only invest what you*/}
          {/*  can afford to lose. Past performance does not guarantee future*/}
          {/*  results.*/}
          {/*</Typography>*/}
        </div>
        <div className={classes.right}>
          <div className={classes.footerSocials}>
            {SOCIAL_LINKS.map(({ title, icon, path }) => (
              <Link
                key={`${title}-footer`}
                pathname={path}
                className={classes.icon}
                isNewTab
              >
                {icon}
              </Link>
            ))}
          </div>
          {/*<div className={classes.textWrap}>*/}
          {/*  {[*/}
          {/*    'Audited Contracts',*/}
          {/*    'Transparent On-Chain Strategy',*/}
          {/*    'Real-Time Treasury Tracking',*/}
          {/*  ].map((item) => (*/}
          {/*    <Typography*/}
          {/*      variant="subtitle1"*/}
          {/*      color={(theme) => theme.palette.custom.text.light}*/}
          {/*      key={item}*/}
          {/*      className={classes.textItem}*/}
          {/*    >*/}
          {/*      {item}*/}
          {/*    </Typography>*/}
          {/*  ))}*/}
          {/*</div>*/}
          <Typography
            variant="body2"
            color={(theme) => theme.palette.custom.text.light}
          >
            © {CURRENT_YEAR} Hit the Yield. All rights reserved.
          </Typography>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
